<!-- RentWise Table -->
<section>
    <div class="content-box">
        <h1><b>Housing Provider Education Public Records</b></h1>
        <div class="card">
            <div class="card-body" style="overflow-x:auto;">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Primary Role</th>
                            <th>Company Name</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Date Completed</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of users">
                            <td>{{ user.firstName }}</td>
                            <td>{{ user.lastName }}</td>
                            <td>{{ user.email }}</td>
                            <td>
                              <span *ngIf="user.primaryRole === 'Other' && user.primaryRoleOther">{{ user.primaryRole }} – {{ user.primaryRoleOther }}</span>
                              <span *ngIf="!(user.primaryRole === 'Other' && user.primaryRoleOther)">{{ user.primaryRole || 'N/A' }}</span>
                            </td>
                            <td>{{ user.companyName || 'N/A' }}</td>
                            <td>{{ user.city || 'N/A' }}</td>
                            <td>{{ user.state || 'N/A' }}</td>
                            <td>{{ (user.fheCompletionDate | date:'mediumDate') || 'N/A' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</section>
